/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/articles.
 *
 * `title` mirrors the zh-Hant value (backward compat for every
 * existing consumer that reads it). For locale-aware UI, read
 * the per-locale `title_zhHant/zhHans/en` fields instead — the
 * filter in NewsTeaser uses these to decide which articles to
 * show in each locale. Empty string means that locale has no
 * translation in the DB; the consumer is expected to fall back
 * per its own chain (server uses zh-Hant → en).
 */

export interface CmsArticleIndexEntry {
  slug: string
  /** Locale-collapsed (zh-Hant) for backward compat. */
  title: string
  /** Locale-collapsed (zh-Hant) for backward compat. */
  excerpt: string
  title_zhHant: string
  title_zhHans: string
  title_en: string
  excerpt_zhHant: string
  excerpt_zhHans: string
  excerpt_en: string
  cover_media_id: number | null
  cover_media_uuid: string | null
  published_at: number | null
  seo: Record<string, unknown>
  template_key: string | null
  tags?: string[]
}

export const cmsArticles: CmsArticleIndexEntry[] = [
  {
    "slug": "AI不是給答案而是出題-下集-提問教練",
    "title": "AI 不是給答案，而是出題（下）：從答案機器到提問教練",
    "excerpt": "AI 應該是答案提供者，還是提問教練？這一篇談 cognitive debt cycle、動態漸進難度、針對弱點的陷阱題與模擬實境練習，並指出 AI 生成練習的邊界：方便不等於容易，學習動機才是學習的引擎。",
    "title_zhHant": "AI 不是給答案，而是出題（下）：從答案機器到提問教練",
    "title_zhHans": "AI 不是给答案，而是出题（下）：从答案机器到提问教练",
    "title_en": "AI Should Not Give Answers, but Ask Questions (Part 2): From Answer Machine to Questioning Coach",
    "excerpt_zhHant": "AI 應該是答案提供者，還是提問教練？這一篇談 cognitive debt cycle、動態漸進難度、針對弱點的陷阱題與模擬實境練習，並指出 AI 生成練習的邊界：方便不等於容易，學習動機才是學習的引擎。",
    "excerpt_zhHans": "AI 应该是答案提供者，还是提问教练？这一篇谈 cognitive debt cycle、动态渐进难度、针对弱点的陷阱题与模拟实境练习，并指出 AI 生成练习的边界：方便不等于容易，学习动机才是学习的引擎。",
    "excerpt_en": "Should AI be an answer provider or a questioning coach? This part covers the cognitive debt cycle, dynamic progressive difficulty, trap questions for misconceptions, and simulated exam practice — and draws the line: convenience is not ease, and motivation is the engine of learning.",
    "published_at": 1792545271105,
    "cover_media_id": 40,
    "cover_media_uuid": "35fd6df8-394e-42f7-9b45-a26079369d2c",
    "seo": {
      "zhHant": {
        "metaTitle": "AI 不是給答案，而是出題（下）｜提問教練",
        "metaDescription": "AI 可以是答案機器，也可以是提問教練。了解漸進難度、陷阱題與模擬實境練習，以及為何學習動機才是學習的引擎。",
        "tags": [
          "AI 教育",
          "提問教練",
          "cognitive debt",
          "zone of proximal development",
          "學習動機"
        ]
      },
      "zhHans": {},
      "en": {}
    },
    "template_key": null,
    "tags": [
      "AI 教育",
      "cognitive debt",
      "zone of proximal development",
      "學習動機",
      "提問教練",
      "總監專欄"
    ]
  },
  {
    "slug": "AI不是給答案而是出題-上集-提取練習",
    "title": "AI 不是給答案，而是出題（上）：提取練習打破「學會了」的錯覺",
    "excerpt": "有些學生花大量時間複習，考試時卻腦袋空白；有些學生只花五分之一時間，卻能把內容牢牢記住。真正的差別不在聰明程度，而在學習方法。這一篇談反覆閱讀的陷阱，以及提取練習與費曼技巧如何把「熟悉感」變成真正的掌握。",
    "title_zhHant": "AI 不是給答案，而是出題（上）：提取練習打破「學會了」的錯覺",
    "title_zhHans": "AI 不是给答案，而是出题（上）：提取练习打破「学会了」的错觉",
    "title_en": "AI Should Not Give Answers, but Ask Questions (Part 1): Retrieval Practice Breaks the Illusion of Knowing",
    "excerpt_zhHant": "有些學生花大量時間複習，考試時卻腦袋空白；有些學生只花五分之一時間，卻能把內容牢牢記住。真正的差別不在聰明程度，而在學習方法。這一篇談反覆閱讀的陷阱，以及提取練習與費曼技巧如何把「熟悉感」變成真正的掌握。",
    "excerpt_zhHans": "有些学生花大量时间复习，考试时却脑袋空白；有些学生只花五分之一时间，却能把内容牢牢记住。真正的差别不在聪明程度，而在学习方法。这一篇谈反复阅读的陷阱，以及提取练习与费曼技巧如何把「熟悉感」变成真正的掌握。",
    "excerpt_en": "Some students spend hours revising and freeze in the exam; others spend a fifth of the time and remember everything. The difference is not intelligence but method. This part explains the trap of re-reading, and how retrieval practice and the Feynman Technique turn familiarity into real mastery.",
    "published_at": 1792545271105,
    "cover_media_id": 39,
    "cover_media_uuid": "d1df4006-1a65-4f45-8e32-c02f8effa67b",
    "seo": {
      "zhHant": {
        "metaTitle": "AI 不是給答案，而是出題（上）｜提取練習",
        "metaDescription": "反覆閱讀只會製造「學會了」的錯覺。了解 Karpicke & Blunt（2011）的 retrieval practice 研究，以及費曼技巧如何把熟悉感變成真正的掌握。",
        "tags": [
          "提取練習",
          "retrieval practice",
          "費曼技巧",
          "Feynman Technique",
          "認知科學",
          "學習方法"
        ]
      },
      "zhHans": {},
      "en": {}
    },
    "template_key": null,
    "tags": [
      "Feynman Technique",
      "retrieval practice",
      "學習方法",
      "提取練習",
      "總監專欄",
      "認知科學",
      "費曼技巧"
    ]
  },
  {
    "slug": "實用溫習策略",
    "title": "實用溫習策略",
    "excerpt": "把溫習變成長期記憶,六大方法從「記住鎖匙」到「記得課本」:腦海快照、CAMPP 縮寫記憶、分隔溫習、主動自我測試,以及充足睡眠。",
    "title_zhHant": "實用溫習策略",
    "title_zhHans": "实用温习策略",
    "title_en": "Practical Revision Strategies",
    "excerpt_zhHant": "把溫習變成長期記憶,六大方法從「記住鎖匙」到「記得課本」:腦海快照、CAMPP 縮寫記憶、分隔溫習、主動自我測試,以及充足睡眠。",
    "excerpt_zhHans": "把温习变成长期记忆,六大方法从「记住锁匙」到「记得课本」:脑海快照、CAMPP 缩写记忆、分隔温习、主动自我测试,以及充足睡眠。",
    "excerpt_en": "Turn revision into long-term memory with six methods, from \"remembering your keys\" to \"recalling the textbook\": mind snapshots, the CAMPP acronym, spaced revision, active self-testing, and plenty of sleep.",
    "published_at": 1791874785010,
    "cover_media_id": 23,
    "cover_media_uuid": "a1b36ff8-eea7-44b4-b6ef-b288bde4a001",
    "seo": {
      "zhHant": {
        "keywords": [
          "溫習策略",
          "學習方法",
          "記憶技巧",
          "間隔重複",
          "主動回憶",
          "睡眠學習",
          "CAMPP"
        ]
      },
      "zhHans": {
        "keywords": [
          "复习策略",
          "学习方法",
          "记忆技巧",
          "间隔重复",
          "主动回忆",
          "睡眠学习",
          "CAMPP"
        ]
      },
      "en": {
        "keywords": [
          "study strategies",
          "learning methods",
          "memory techniques",
          "spaced repetition",
          "active recall",
          "sleep learning",
          "CAMPP"
        ]
      }
    },
    "template_key": null,
    "tags": []
  },
  {
    "slug": "科技賦能品格培養",
    "title": "科技如何賦能品格培養及價值觀教育",
    "excerpt": "世界愈趨科技化,價值觀及品格教育就愈重要。在數碼轉型浪潮與《價值觀教育課程架構(2026)》推動下,科技如何賦能道德與價值觀教育,已成為最受矚目的前沿課題。",
    "title_zhHant": "科技如何賦能品格培養及價值觀教育",
    "title_zhHans": "科技如何赋能品格培养及价值观教育",
    "title_en": "How Technology Empowers Character Development and Values Education",
    "excerpt_zhHant": "世界愈趨科技化,價值觀及品格教育就愈重要。在數碼轉型浪潮與《價值觀教育課程架構(2026)》推動下,科技如何賦能道德與價值觀教育,已成為最受矚目的前沿課題。",
    "excerpt_zhHans": "世界愈趋科技化,价值观及品格教育就愈重要。在数码转型浪潮与《价值观教育课程架构(2026)》推动下,科技如何赋能道德与价值观教育,已成为最受瞩目的前沿课题。",
    "excerpt_en": "The more technology-driven our world becomes, the more important values and character education becomes. Under the wave of digital transformation and the promotion of the \"Curriculum Framework on Values Education (2026)\", how technology can empower moral and values education has become one of the most prominent frontier topics.",
    "published_at": 1791811089900,
    "cover_media_id": 22,
    "cover_media_uuid": "09459a3a-9201-4ab7-8319-a05a1cb7bbb9",
    "seo": {
      "zhHant": {
        "keywords": [
          "教育科技",
          "品格教育",
          "價值觀教育",
          "AI",
          "遊戲化學習",
          "家校合作",
          "ValuesIncubator"
        ]
      },
      "zhHans": {},
      "en": {}
    },
    "template_key": null,
    "tags": [
      "AI",
      "價值觀教育",
      "品格教育",
      "家校合作",
      "教育科技",
      "遊戲化學習"
    ]
  }
]
